import { api } from "@/lib/api/api";
import { expectShape } from "@/lib/expect/expect-shape";
import { is } from "@/lib/is/is";
import { out } from "@/lib/output/out";
import type { ApiOutputs } from "@/lib/api/api-outputs";

export async function listApprovals(asJson: boolean): Promise<void> {
  const result = expectShape<ApiOutputs["approvals"]["list"]>(
    await api("/approvals"),
    "GET /approvals",
    { items: is.array },
  );
  if (asJson) {
    out.json(result);
    return;
  }
  if (result.items.length === 0) {
    out.line("No guardrail waiting on you.");
    return;
  }
  out.table(
    result.items.map((item) => [
      out.cell(item.id),
      out.cell(item.guardrailKind),
      out.cell(item.repoName ?? "-"),
      out.cell(item.summary),
    ]),
  );
}
